<!--
 * @Author: 桥洞里面盖小被 1353427375@qq.com
 * @Date: 2024-05-27 12:50:21
 * @LastEditors: Xia Huang 60800828+caiqingwen@users.noreply.github.com
 * @LastEditTime: 2025-05-30 14:12:29
 * @FilePath: \three-renderquick\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <canvas id="text-canvas" style="display: none"></canvas>
  <div class="gui">
    <div class="navigation">
      <li v-for="(item, index) in menuItems" :key="index" :class="{ selected: selectedItem === index }" @click="selectItem(index)">
        <a>{{ item }}</a>
      </li>
      <span class="toggleMenu"></span>
    </div>
    <div class="function-area">
      <div class="function-area-item" v-show="selectedItem === 0">
        <div class="function-area-item-part" id="begingSetting1">
          <div class="button-option" @click="loadConfiguration">导入配置</div>
          <div class="button-option" @click="saveConfiguration">导出配置</div>
        </div>
        <div class="function-area-item-part">
          <div class="button-option" @click="exportOBJModel">导出OBJ文件</div>
          <div class="button-option" @click="exportGLTFModel">导出GLTF文件</div>
        </div>
      </div>
      <div class="function-area-item" v-show="selectedItem === 1">
        <div class="function-area-item-part">
          <div class="checkbox-option">
            <div class="option-label">显示坐标轴</div>
            <div class="option-value">
              <input type="checkbox" class="checkbox-input" v-model="baseData.showAxies">
            </div>
          </div>
          <div class="checkbox-option">
            <div class="option-label">显示停车位</div>
            <div class="option-value">
              <input type="checkbox" class="checkbox-input" v-model="baseData.showParkingSpace">
            </div>
          </div>
          <div class="checkbox-option">
            <div class="option-label">显示墙壁</div>
            <div class="option-value">
              <input type="checkbox" class="checkbox-input" v-model="baseData.showWall">
            </div>
          </div>
          <div class="checkbox-option">
            <div class="option-label">显示车道线</div>
            <div class="option-value">
              <input type="checkbox" class="checkbox-input" v-model="baseData.showLaneLines">
            </div>
          </div>
          <div class="checkbox-option">
            <div class="option-label">显示地板</div>
            <div class="option-value">
              <input type="checkbox" class="checkbox-input" v-model="baseData.showGround">
            </div>
          </div>
        </div>
        <div class="function-area-item-part">
          <div class="checkbox-option">
            <div class="option-label">显示停车位背景</div>
            <div class="option-value">
              <input type="checkbox" class="checkbox-input" v-model="baseData.showParkingSpaceBackground">
            </div>
          </div>
          <div class="checkbox-option">
            <div class="option-label">显示电梯</div>
            <div class="option-value">
              <input type="checkbox" class="checkbox-input" v-model="baseData.showElevator">
            </div>
          </div>
        </div>
      </div>
      <div class="function-area-item" v-show="selectedItem === 2">
        <div class="function-area-item-part">
          <div class="checkbox-option">
            <div class="option-label">是否透明</div>
            <div class="option-value">
              <input type="checkbox" class="checkbox-input" v-model="groundData.transparent">
            </div>
          </div>
          <div class="range-option">
            <div class="option-label">透明度</div>
            <div class="option-value">
              <input type="range" class="range-input" min="0" max="1" step="0.01" v-model="groundData.opacity">
              <span>{{ groundData.opacity }}</span>
            </div>
          </div>
          <div class="color-options">
            <div class="option-label">颜色</div>
            <div class="option-value">
              <input type="color" class="color-input" v-model="groundData.color">
            </div>
          </div>
        </div>
        <div class="function-area-item-part">
          <div class="choice-option">
            <div class="option-label">材质选择</div>
            <div class="option-value">
              <div class="choice-input">
                <select v-model="groundData.material">
                  <option>基础材质</option>
                  <option>卡通材质</option>
                  <option>Blinn-Phong模型材质</option>
                  <option>Lambertian模型材质</option>
                  <option>物理模型材质</option>
                  <option>标准材质</option>
                </select>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 6" class="sprites">
                  <symbol id="select-arrow-down" viewBox="0 0 10 6">
                    <polyline points="1 1 5 5 9 1"></polyline>
                  </symbol>
                  <use xlink:href="#select-arrow-down"></use>
                </svg>
              </div>
            </div>
          </div>
          <div class="upload-option">
            <div class="option-label">上传贴图</div>
            <div class="option-value">
              <div class="upload-input">
                选择图片
                <input type="file" accept="image/*" @change="uploadGroundMaterialMap">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="function-area-item" v-show="selectedItem === 3">
        <div class="function-area-item-part">
          <div class="checkbox-option">
            <div class="option-label">是否透明</div>
            <div class="option-value">
              <input type="checkbox" class="checkbox-input" v-model="parkingSpaceData.transparent">
            </div>
          </div>
          <div class="range-option">
            <div class="option-label">透明度</div>
            <div class="option-value">
              <input type="range" class="range-input" min="0" max="1" step="0.01" v-model="parkingSpaceData.opacity">
              <span>{{ parkingSpaceData.opacity }}</span>
            </div>
          </div>
          <div class="color-options">
            <div class="option-label">颜色</div>
            <div class="option-value">
              <input type="color" class="color-input" v-model="parkingSpaceData.color">
            </div>
          </div>
        </div>
        <div class="function-area-item-part">
          <!-- <div class="range-option">
            <div class="option-label">停车位边框线宽度</div>
            <div class="option-value">
              <input type="range" class="range-input" min="0" max="10" step="0.01" v-model="parkingSpaceData.parkingSpaceBorderLineWidth">
              <span>{{ parkingSpaceData.parkingSpaceBorderLineWidth }}</span>
            </div>
          </div> -->
          <div class="color-options">
            <div class="option-label">停车位边框线颜色</div>
            <div class="option-value">
              <input type="color" class="color-input" v-model="parkingSpaceData.parkingSpaceBorderLineColor">
            </div>
          </div>
          <div class="color-options">
            <div class="option-label">阻车器颜色</div>
            <div class="option-value">
              <input type="color" class="color-input" v-model="parkingSpaceData.arresterColor">
            </div>
          </div>
        </div>
        <div class="function-area-item-part">
          <div class="choice-option">
            <div class="option-label">材质选择</div>
            <div class="option-value">
              <div class="choice-input">
                <select v-model="parkingSpaceData.material">
                  <option>基础材质</option>
                  <option>卡通材质</option>
                  <option>Blinn-Phong模型材质</option>
                  <option>Lambertian模型材质</option>
                  <option>物理模型材质</option>
                  <option>标准材质</option>
                </select>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 6" class="sprites">
                  <symbol id="select-arrow-down" viewBox="0 0 10 6">
                    <polyline points="1 1 5 5 9 1"></polyline>
                  </symbol>
                  <use xlink:href="#select-arrow-down"></use>
                </svg>
              </div>
            </div>
          </div>
          <div class="upload-option">
            <div class="option-label">上传贴图</div>
            <div class="option-value">
              <div class="upload-input">
                选择图片
                <input type="file" accept="image/*" @change="uploadParkingSpaceMaterialMap">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="function-area-item" v-show="selectedItem === 4">
        <div class="function-area-item-part">
          <div class="checkbox-option">
            <div class="option-label">是否透明</div>
            <div class="option-value">
              <input type="checkbox" class="checkbox-input" v-model="wallData.transparent">
            </div>
          </div>
          <div class="range-option">
            <div class="option-label">透明度</div>
            <div class="option-value">
              <input type="range" class="range-input" min="0" max="1" step="0.01" v-model="wallData.opacity">
              <span>{{ wallData.opacity }}</span>
            </div>
          </div>
          <div class="color-options">
            <div class="option-label">颜色</div>
            <div class="option-value">
              <input type="color" class="color-input" v-model="wallData.color">
            </div>
          </div>
          <div class="range-option">
            <div class="option-label">高度</div>
            <div class="option-value">
              <input type="range" class="range-input" min="0.01" max="3" step="0.01" v-model="wallData.height">
              <span>{{ wallData.height }}</span>
            </div>
          </div>
        </div>
        <div class="function-area-item-part">
          <div class="choice-option">
            <div class="option-label">材质选择</div>
            <div class="option-value">
              <div class="choice-input">
                <select v-model="wallData.material">
                  <option>基础材质</option>
                  <option>卡通材质</option>
                  <option>Blinn-Phong模型材质</option>
                  <option>Lambertian模型材质</option>
                  <option>物理模型材质</option>
                  <option>标准材质</option>
                </select>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 6" class="sprites">
                  <symbol id="select-arrow-down" viewBox="0 0 10 6">
                    <polyline points="1 1 5 5 9 1"></polyline>
                  </symbol>
                  <use xlink:href="#select-arrow-down"></use>
                </svg>
              </div>
            </div>
          </div>
          <div class="upload-option">
            <div class="option-label">上传贴图</div>
            <div class="option-value">
              <div class="upload-input">
                选择图片
                <input type="file" accept="image/*" @change="uploadWallMaterialMap">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="function-area-item" v-show="selectedItem === 5">
        <div class="function-area-item-part">
          <div class="color-options">
            <div class="option-label">颜色</div>
            <div class="option-value">
              <input type="color" class="color-input" v-model="laneLinesData.color">
            </div>
          </div>
        </div>
      </div>
      <div class="function-area-item" v-show="selectedItem === 6">
        <div class="function-area-item-part">
          <div class="checkbox-option">
            <div class="option-label">是否透明</div>
            <div class="option-value">
              <input type="checkbox" class="checkbox-input" v-model="elevatorData.transparent">
            </div>
          </div>
          <div class="range-option">
            <div class="option-label">透明度</div>
            <div class="option-value">
              <input type="range" class="range-input" min="0" max="1" step="0.01" v-model="elevatorData.opacity">
              <span>{{ elevatorData.opacity }}</span>
            </div>
          </div>
          <div class="color-options">
            <div class="option-label">颜色</div>
            <div class="option-value">
              <input type="color" class="color-input" v-model="elevatorData.color">
            </div>
          </div>
          <div class="range-option">
            <div class="option-label">高度</div>
            <div class="option-value">
              <input type="range" class="range-input" min="0.01" max="3" step="0.01" v-model="elevatorData.height">
              <span>{{ elevatorData.height }}</span>
            </div>
          </div>
        </div>
        <div class="function-area-item-part">
          <div class="choice-option">
            <div class="option-label">材质选择</div>
            <div class="option-value">
              <div class="choice-input">
                <select v-model="elevatorData.material">
                  <option>基础材质</option>
                  <option>卡通材质</option>
                  <option>Blinn-Phong模型材质</option>
                  <option>Lambertian模型材质</option>
                  <option>物理模型材质</option>
                  <option>标准材质</option>
                </select>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 6" class="sprites">
                  <symbol id="select-arrow-down" viewBox="0 0 10 6">
                    <polyline points="1 1 5 5 9 1"></polyline>
                  </symbol>
                  <use xlink:href="#select-arrow-down"></use>
                </svg>
              </div>
            </div>
          </div>
          <div class="upload-option">
            <div class="option-label">上传贴图</div>
            <div class="option-value">
              <div class="upload-input">
                选择图片
                <input type="file" accept="image/*" @change="uploadElevatorMaterialMap">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="function-area-item" v-show="selectedItem === 7">
        <div class="function-area-item-part">
          <div class="color-options">
            <div class="option-label">颜色</div>
            <div class="option-value">
              <input type="color" class="color-input" v-model="parkingSpaceBackgroundData.color">
            </div>
          </div>
        </div>
      </div>
      <div class="function-area-item" v-show="selectedItem === 8">
        <div class="function-area-item-part">
          <div class="checkbox-option">
            <div class="option-label">环境光源</div>
            <div class="option-value">
              <input type="checkbox" class="checkbox-input" v-model="lightData.ambientLight">
            </div>
          </div>
          <div class="checkbox-option">
            <div class="option-label">平行光源</div>
            <div class="option-value">
              <input type="checkbox" class="checkbox-input" v-model="lightData.directionalLight">
            </div>
          </div>
          <div class="checkbox-option">
            <div class="option-label">点光源</div>
            <div class="option-value">
              <input type="checkbox" class="checkbox-input" v-model="lightData.pointLight">
            </div>
          </div>
        </div>
        <div class="function-area-item-part">
          <div class="range-option">
            <div class="option-label">环境光源强度</div>
            <div class="option-value">
              <input type="range" class="range-input" min="0" max="10" step="0.1" v-model="lightData.ambientLightIntensity">
              <span>{{ lightData.ambientLightIntensity }}</span>
            </div>
          </div>
          <div class="color-options">
            <div class="option-label">环境光源颜色</div>
            <div class="option-value">
              <input type="color" class="color-input" v-model="lightData.ambientLightColor">
            </div>
          </div>
        </div>
        <div class="function-area-item-part">
          <div class="range-option">
            <div class="option-label">平行光源强度</div>
            <div class="option-value">
              <input type="range" class="range-input" min="0" max="10" step="0.1" v-model="lightData.directionalLightIntensity">
              <span>{{ lightData.directionalLightIntensity }}</span>
            </div>
          </div>
          <div class="color-options">
            <div class="option-label">平行光源颜色</div>
            <div class="option-value">
              <input type="color" class="color-input" v-model="lightData.directionalLightColor">
            </div>
          </div>
          <div class="range-option">
            <div class="option-label">平行光源X坐标</div>
            <div class="option-value">
              <input type="range" class="range-input" min="-20" max="20" step="0.01" v-model="lightData.directionalLightPositionX">
              <span>{{ lightData.directionalLightPositionX }}</span>
            </div>
          </div>
          <div class="range-option">
            <div class="option-label">平行光源Y坐标</div>
            <div class="option-value">
              <input type="range" class="range-input" min="-20" max="20" step="0.01" v-model="lightData.directionalLightPositionY">
              <span>{{ lightData.directionalLightPositionY }}</span>
            </div>
          </div>
          <div class="range-option">
            <div class="option-label">平行光源Z坐标</div>
            <div class="option-value">
              <input type="range" class="range-input" min="-20" max="20" step="0.01" v-model="lightData.directionalLightPositionZ">
              <span>{{ lightData.directionalLightPositionZ }}</span>
            </div>
          </div>
        </div>
        <div class="function-area-item-part">
          <div class="range-option">
            <div class="option-label">点光源强度</div>
            <div class="option-value">
              <input type="range" class="range-input" min="0" max="10" step="0.1" v-model="lightData.pointLightIntensity">
              <span>{{ lightData.pointLightIntensity }}</span>
            </div>
          </div>
          <div class="color-options">
            <div class="option-label">点光源颜色</div>
            <div class="option-value">
              <input type="color" class="color-input" v-model="lightData.pointLightColor">
            </div>
          </div>
          <div class="range-option">
            <div class="option-label">点光源X坐标</div>
            <div class="option-value">
              <input type="range" class="range-input" min="-20" max="20" step="0.01" v-model="lightData.pointLightPositionX">
              <span>{{ lightData.pointLightPositionX }}</span>
            </div>
          </div>
          <div class="range-option">
            <div class="option-label">点光源Y坐标</div>
            <div class="option-value">
              <input type="range" class="range-input" min="-20" max="20" step="0.01" v-model="lightData.pointLightPositionY">
              <span>{{ lightData.pointLightPositionY }}</span>
            </div>
          </div>
          <div class="range-option">
            <div class="option-label">点光源Z坐标</div>
            <div class="option-value">
              <input type="range" class="range-input" min="-20" max="20" step="0.01" v-model="lightData.pointLightPositionZ">
              <span>{{ lightData.pointLightPositionZ }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { onMounted, ref, watch, reactive} from 'vue';
  import * as THREE from 'three';
  import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js';
  import { CSS2DRenderer, CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js';
  import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js';
  import { OBJExporter } from 'three/examples/jsm/exporters/OBJExporter.js';
  import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
  import * as render from './utils/render';
  import * as BufferGeometryUtils from 'three/addons/utils/BufferGeometryUtils.js';
  import Quadtree from '@timohausmann/quadtree-js';

  /**************************下拉框操作************************* */




  /**********************************GUI配置变量************************** */
  const baseData = reactive({
    showAxies: false,                // 是否显示坐标轴
    showParkingSpace: true,          // 是否显示停车位
    showWall: true,                  // 是否显示墙壁
    showLaneLines: true,             // 是否显示车道线
    showGround: true,                // 是否显示地板
    showParkingSpaceBackground : true,   // 是否显示停车位背景
    showElevator: true,              // 是否显示电梯
  })
  const groundData = reactive({
    color :  "#211d0e",                //0x757575, // 颜色
    transparent: false,                // 是否透明
    opacity: 1,                        // 透明度
    material: 'Blinn-Phong模型材质',
    texture: null,
  })
  const parkingSpaceData = reactive({
    color :  "#2e4228",                    // 颜色0x00adb5  004d00 FFAF45 0x3e931a
    transparent: false,                    // 是否透明
    opacity: 1,                            // 透明度
    height: 0.0001,
    parkingSpaceBorderLineWidth: 1,
    parkingSpaceBorderLineColor: "#ffffff",
    arresterColor: "#000000", 
    parkingSpaceNumberShowByMesh: true,
    parkingSpaceNumberShowByCss: true,
    parkingSpaceNumberShowByMeshColor: 0xffffff,
    parkingSpaceNumberShowByMeshSize: 1,
    material: 'Blinn-Phong模型材质',
    texture: null,
  })
  const wallData = reactive({
    color :  "#b4b4c9", // 颜色  eeeeee
    transparent: true, // 是否透明
    opacity: 1, // 透明度
    height: 0.1,    // 高度
    material: 'Blinn-Phong模型材质',
    texture: null,
  })
  const elevatorData = reactive({
    color :  "#dbe2ef", // 颜色
    transparent: true, // 是否透明
    opacity: 1, // 透明度
    height: 0.3, // 高度
    material: 'Blinn-Phong模型材质',
    texture: null,
  })
  const laneLinesData = reactive({
    color :  "#ffffff", // 颜色
  })
  const parkingSpaceBackgroundData = reactive({
    color :  "#a2acae", //0x8D9295, // 颜色
  })
  const lightData = reactive({
    ambientLight: true,           // 环境光是否开启
    directionalLight: true,       // 平行光是否开启
    pointLight: false,             // 点光源是否开启
    ambientLightIntensity: 0.5,     // 环境光强度
    directionalLightIntensity: 5, // 平行光强度
    pointLightIntensity: 5,       // 点光源强度
    ambientLightColor: "#ffffff",     // 环境光颜色
    directionalLightColor: "#ffffff", // 平行光颜色
    pointLightColor: "#ffffff",       // 点光源颜色
    // 点光源位置
    pointLightPositionX: -3.3,
    pointLightPositionY: 5.38,
    pointLightPositionZ: 10.9,
    // 平行光位置
    directionalLightPositionX: -3.3,
    directionalLightPositionY: 5.38,
    directionalLightPositionZ: 10.9
  })






  /************************HTML页面控制参数变量******************************* */
  // 菜单导航栏参数
  const menuItems = ref([
    '开始',
    '基础设置',
    '地板设置',
    '停车位设置',
    '墙壁设置',
    '车道线设置',
    '电梯设置',
    '停车位背景设置',
    '光源设置',
  ]);
  // 菜单导航栏选中的选项
  const selectedItem = ref(0);
  const selectItem = (index) => {
    selectedItem.value = index;
  };

  /******************************渲染地图的相关数据****************************/
  // 存储地图信息
  let mapInfo = null;
  // 确定three.js渲染设置
  // 定义屏幕的宽度和高度
  const width = window.innerWidth, height = window.innerHeight;
  // 创建相机
  const camera = new THREE.PerspectiveCamera(90, width / height, 0.01, 1000);
  camera.up.set(0, 0, 1);   // 设置让z轴朝上
  // 创建场景
  const scene = new THREE.Scene();
  // 设置背景颜色
  scene.background = new THREE.Color(0xC4DFFD);
  // scene.background = new THREE.Color(0x000000);
  // 创建坐标轴
  const axesHelper = new THREE.AxesHelper(15);
  if (baseData.showAxies) {
    scene.add(axesHelper);
  }
  // 创建渲染器
  const renderer = new THREE.WebGLRenderer( { antialias: true } );
  renderer.setSize( width, height );
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  document.body.appendChild( renderer.domElement );
  // 创建CSS2DRenderer渲染器
  const labelRenderer = new CSS2DRenderer();
  labelRenderer.setSize(window.innerWidth, window.innerHeight);
  labelRenderer.domElement.style.position = 'absolute';
  labelRenderer.domElement.style.top = '0px';
  document.body.appendChild(labelRenderer.domElement);
  // 创建轨道控制器
  const controls = new OrbitControls( camera, labelRenderer.domElement );
  // 设置缩放的范围
  controls.minDistance = 0.0000000000000000001;
  controls.maxDistance = 1000;
  controls.update();
  // 设置旋转范围
  controls.minPolarAngle = 0;
  controls.maxPolarAngle = (Math.PI / 2) * 0.75;
  controls.enableDamping = true

  // icpark
  // const cameraPosition = [7.5142798527992225, 11.030342521181929, 4.23404982501489]
  // const cameraLookDirection = [-0.31200340978890634, -0.4294586746029716, -0.8474780935743146]
  // const delta = 5;
  // camera.position.set(cameraPosition[0], cameraPosition[1], cameraPosition[2]);
  // const lookPosition = new THREE.Vector3(cameraPosition[0] + delta * cameraLookDirection[0], cameraPosition[1] + delta * cameraLookDirection[1], cameraPosition[2] + delta * cameraLookDirection[2]);
  // camera.lookAt(cameraPosition[0] + delta * cameraLookDirection[0], cameraPosition[1] + delta * cameraLookDirection[1], cameraPosition[2] + delta * cameraLookDirection[2]);
  // controls.target.copy(lookPosition);
  // camera.updateMatrixWorld();
  
  // 海兴
  // camera.position.set(0.661519, 1.3802557, 2.2687340)
  // camera.lookAt(1.5545187, 1.37744, 0.09127238)
  // controls.target.set(1.5545187, 1.37744, 0.09127238)
  // camera.updateMatrixWorld();

  // maikeduo
  // const cameraPosition = [4.7063041044, 1.69210496, 2.683391];
  // const targetControl = [0.76633128, 1.68924129, -3.35681056];
  // camera.position.set(cameraPosition[0], cameraPosition[1], cameraPosition[2]);
  // camera.lookAt(targetControl[0], targetControl[1], targetControl[2]);
  // controls.target.set(targetControl[0], targetControl[1], targetControl[2]);
  // camera.updateMatrixWorld();

  // konggang_B1
  // const cameraPosition = [87.57269, 75.491911, 6.1486089];
  // const targetControl = [42.497267, 75.2782, -56.857788];
  // camera.position.set(cameraPosition[0], cameraPosition[1], cameraPosition[2]);
  // camera.lookAt(targetControl[0], targetControl[1], targetControl[2]);
  // controls.target.set(targetControl[0], targetControl[1], targetControl[2]);
  // camera.updateMatrixWorld();

  // konggang_B2
  // const cameraPosition = [53.74, 144, 4.5414];
  // const targetControl = [53.75, 149.29, -6.3217];
  // camera.position.set(cameraPosition[0], cameraPosition[1], cameraPosition[2]);
  // camera.lookAt(targetControl[0], targetControl[1], targetControl[2]);
  // controls.target.set(targetControl[0], targetControl[1], targetControl[2]);
  // camera.updateMatrixWorld();

  // qibuguangchang_B1
  // const cameraPosition = [12, 27, 9];
  // const targetControl = [44, 27, -42];
  // camera.position.set(cameraPosition[0], cameraPosition[1], cameraPosition[2]);
  // camera.lookAt(targetControl[0], targetControl[1], targetControl[2]);
  // controls.target.set(targetControl[0], targetControl[1], targetControl[2]);
  // camera.updateMatrixWorld();

  // // qibuguangchang_B2
  // const cameraPosition = [-0.11, 4.9, 5.9];
  // const targetControl = [31, 4.9, -49.8];
  // camera.position.set(cameraPosition[0], cameraPosition[1], cameraPosition[2]);
  // camera.lookAt(targetControl[0], targetControl[1], targetControl[2]);
  // controls.target.set(targetControl[0], targetControl[1], targetControl[2]);
  // camera.updateMatrixWorld();

  // // // dayuecheng
  // const cameraPosition = [6.8084136643525115, 8.028795785331663, 5.231740251145248];
  // const targetControl = [1.1565258020514981, 7.686219985249533, -7.284986952448537];
  // camera.position.set(cameraPosition[0], cameraPosition[1], cameraPosition[2]);
  // camera.lookAt(targetControl[0], targetControl[1], targetControl[2]);
  // controls.target.set(targetControl[0], targetControl[1], targetControl[2]);
  // camera.updateMatrixWorld();

  
  // // // maikeduo
  // const cameraPosition = [3.5017840503700888, -1.9836833813675918, 3.189734570660299];
  // const targetControl = [2.377843389681692, 5.836746274474343, -6.518308346323115];
  // camera.position.set(cameraPosition[0], cameraPosition[1], cameraPosition[2]);
  // camera.lookAt(targetControl[0], targetControl[1], targetControl[2]);
  // controls.target.set(targetControl[0], targetControl[1], targetControl[2]);
  // camera.updateMatrixWorld();

  // // dixiashi
  const cameraPosition = [9.583937716313146, 21.8972222242245, 4.2738474229319126];
  const targetControl = [11.673648235139177, 22.52746468145719, 0.24212392949514588];
  camera.position.set(cameraPosition[0], cameraPosition[1], cameraPosition[2]);
  camera.lookAt(targetControl[0], targetControl[1], targetControl[2]);
  controls.target.set(targetControl[0], targetControl[1], targetControl[2]);
  camera.updateMatrixWorld();


  // 设置轨道控制器的参数，使得用户操作更加便捷
  // 设置旋转，缩放，平移的速度
  controls.rotateSpeed = 0.5;
  controls.zoomSpeed = 1.2;
  controls.panSpeed = 0.8;
  
  // 创建材质(无灯光材质)
  // const materialForParkingSpace = new THREE.MeshBasicMaterial({ color: parkingSpaceData.color, side: THREE.DoubleSide});
  // const materialForParkingSpaceBorder = new THREE.LineBasicMaterial({ color: 0xffffff, side: THREE.DoubleSide});
  // const materialForWall = new THREE.MeshBasicMaterial({color: wallData.color, side: THREE.DoubleSide, transparent: wallData.transparent, opacity: wallData.opacity });
  // const materialForLaneLines = new THREE.LineBasicMaterial({ color: 0xffffff, side: THREE.DoubleSide});
  // const materialForPassageElevator = new THREE.MeshBasicMaterial({ color: 0xdbe2ef, side: THREE.DoubleSide, transparent: true, opacity: 1});
  // const materialForGround = new THREE.MeshBasicMaterial({color: groundData.color, side: THREE.DoubleSide});
  // const materialForParkingSpaceBackground = new THREE.MeshBasicMaterial({color: 0x8D9295});
  // 创建材质（灯光材质）
  const materialForParkingSpace = new THREE.MeshPhongMaterial({ color: parkingSpaceData.color, shininess : 100});
  const materialForParkingSpaceBorder = new THREE.LineBasicMaterial({ color: parkingSpaceData.parkingSpaceBorderLineColor});
  const materialForWall = new THREE.MeshPhongMaterial({color: wallData.color, transparent: wallData.transparent, opacity: wallData.opacity, shininess : 100});
  const materialForLaneLines = new THREE.LineBasicMaterial({ color: laneLinesData.color,  shininess : 100});
  const materialForPassageElevator = new THREE.MeshPhongMaterial({ color: elevatorData.color, transparent: true, opacity: 1});
  const materialForGround = new THREE.MeshPhongMaterial({color: groundData.color, shininess : 100});
  const materialForParkingSpaceBackground = new THREE.MeshPhongMaterial({color: parkingSpaceBackgroundData.color, shininess : 100});
  const materialForArrester = new THREE.MeshPhongMaterial({color: parkingSpaceData.arresterColor, shininess : 100});
  // 添加光源
  // 环境光光源
  const ambientLight = new THREE.AmbientLight(lightData.ambientLightColor, lightData.ambientLightIntensity);
  // 点光源
  const pointLight = new THREE.PointLight(lightData.pointLightColor, lightData.pointLightIntensity, 100);
  pointLight.position.set(lightData.pointLightPositionX, lightData.pointLightPositionY, lightData.pointLightPositionZ);
  pointLight.castShadow = true;
  // 设置阴影的分辨率
  pointLight.shadow.mapSize.width = 2048;
  pointLight.shadow.mapSize.height = 2048;
  // 设置阴影的范围
  pointLight.shadow.camera.near = 0.5;
  pointLight.shadow.camera.far = 500;

  // 存储标签模型的数组
  let labelModels = [];
  

  // 平行光源
  const directionalLight = new THREE.DirectionalLight(lightData.directionalLightColor, lightData.directionalLightIntensity);
  directionalLight.position.set(lightData.directionalLightPositionX, lightData.directionalLightPositionY, lightData.directionalLightPositionZ);
  directionalLight.castShadow = true;
  // 设置阴影的分辨率
  directionalLight.shadow.mapSize.width = 2048;
  directionalLight.shadow.mapSize.height = 2048;
  // 设置阴影的范围
  directionalLight.shadow.camera.left = -10;
  directionalLight.shadow.camera.right = 10;
  directionalLight.shadow.camera.top = 10;
  directionalLight.shadow.camera.bottom = -10;
  directionalLight.shadow.camera.near = 0.5;
  directionalLight.shadow.camera.far = 500;
  // 添加光源到场景中
  if (lightData.ambientLight) {
    scene.add(ambientLight);
  }
  if (lightData.pointLight) {
    scene.add(pointLight);
  }
  if (lightData.directionalLight) {
    scene.add(directionalLight);
  }

  // 加载gtlf模型
  // const gtlfLoader = new GLTFLoader();
  // gtlfLoader.load('carModel/car1/scene.gltf', function (gltf) {
  //   gltf.scene.rotation.x = Math.PI / 2;
  //   gltf.scene.rotation.y = Math.PI / 2;
  //   scene.add(gltf.scene);
  // });
  controls.addEventListener('change', function () {
      // 检查相机的位置，如果y坐标小于某个特定值，就将其修正为该值
      const minHeight = 0.1;
      if (camera.position.z < minHeight) {
          camera.position.z = minHeight;
          // 更新轨道控制器的目标点，以确保相机的视角不会发生跳跃
          controls.target.z = minHeight;
          // 更新视图
          renderer.render(scene, camera);
      }
  });

  // 构建用于标签碰撞检测的四叉树
  let myTree = new Quadtree({
    x : 0,
    y : 0,
    width: window.innerWidth,
    height: window.innerHeight
  });

  /**************************相关函数******************* */

  /**
   * @description: 页面加载完毕后执行的函数
   * @return {*}
   */  
  onMounted(async () => {
    /***********************HTML界面操作变量及指令*********************** */
    let toogleMenu = document.querySelector('.toggleMenu');
    let navigation = document.querySelector('.navigation');
    let functionArea = document.querySelector('.function-area');
    let gui = document.querySelector('.gui');
    toogleMenu.onclick = function() {
      navigation.classList.toggle('active');
      functionArea.classList.toggle('active');
      gui.classList.toggle('active');
    }

    /***********************GUI变量监控函数**************************** */
    // 监听基础设置变量
    watch(baseData, (newVal, oldVal) => {
      if (newVal.showAxies) {
        scene.add(axesHelper);
      } else {
        scene.remove(axesHelper);
      }
      scene.traverse((child) => {
        if (child.userData.type === 'ground') {
          child.visible = newVal.showGround;
        }
        if (child.userData.type === 'parkingSpace') {
          child.visible = newVal.showParkingSpace;
        }
        if (child.userData.type === "parkingSpaceBorder") {
          child.visible = newVal.showParkingSpace;
        }
        if (child.userData.type === "parkingSpaceNumberByMesh") {
          child.visible = newVal.showParkingSpace;
        }
        if (child.userData.type === 'wall') {
          child.visible = newVal.showWall;
        }
        if (child.userData.type === 'laneLines') {
          child.visible = newVal.showLaneLines;
        }
        if (child.userData.type === 'parkingSpaceBorder') {
          child.visible = newVal.showParkingSpace;
        }
        if (child.userData.type === 'elevator') {
          child.visible = newVal.showElevator;
        }
        if (child.userData.type === 'parkingSpaceBackground') {
          child.visible = newVal.showParkingSpaceBackground;
        }
      });
    });
    // 监听地板设置变量
    watch(groundData, (newVal, oldVal) => {
      // 遍历已经渲染的地板，更新其渲染属性
      scene.traverse((child) => {
        if (child.userData.type === 'ground') {
          materialChange(child, newVal);
        }
      });
    });
    // 监听停车位设置变量
    watch(parkingSpaceData, (newVal, oldVal) => {
      // 遍历已经渲染的停车位，更新其渲染属性
      scene.traverse((child) => {
        if (child.userData.type === 'parkingSpace') {
          materialChange(child, newVal);
        }
        if (child.userData.type === 'parkingSpaceBorder') {
          child.material.color.set(newVal.parkingSpaceBorderLineColor);
          child.material.linewidth = newVal.parkingSpaceBorderLineWidth;
        }
        if (child.userData.type === "arrester") {
          child.material.color.set(newVal.arresterColor);
        }
      });
    });
    // 监听墙壁设置变量
    watch(wallData, (newVal, oldVal) => {
      // 遍历已经渲染的墙壁，更新其渲染属性
      scene.traverse((child) => {
        if (child.userData.type === 'wall') {
          materialChange(child, newVal);
          // 修改几何体的高度，
          adjustHeight(child, newVal.height);
          // const orignalHeight = child.geometry.parameters.options.depth;
          // child.scale.z = newVal.height / orignalHeight;
          // child.scale.z = newVal.height / orignalHeight;
        }
      });
    });
    // 监听车道线设置变量
    watch(laneLinesData, (newVal, oldVal) => {
      // 遍历已经渲染的车道线，更新其渲染属性
      scene.traverse((child) => {
        if (child.userData.type === 'laneLines') {
          child.material.color.set(newVal.color);
        }
      });
    });
    // 监听电梯设置变量
    watch(elevatorData, (newVal, oldVal) => {
      // 遍历已经渲染的电梯，更新其渲染属性
      scene.traverse((child) => {
        if (child.userData.type === 'elevator') {
          materialChange(child, newVal);
          // 修改几何体的高度，
          adjustHeight(child, newVal.height);
        }
      });
    });
    // 监听停车位背景设置变量
    watch(parkingSpaceBackgroundData, (newVal, oldVal) => {
      // 遍历已经渲染的停车位背景，更新其渲染属性
      scene.traverse((child) => {
        if (child.userData.type === 'parkingSpaceBackground') {
          child.material.color.set(newVal.color);
        }
      });
    });
    // 监听光源设置变量
    watch(lightData, (newVal, oldVal) => {
      // 更新是否显示环境光源、平行光源、点光源
      if (newVal.ambientLight) {
        scene.add(ambientLight);
      } else {
        scene.remove(ambientLight);
      }
      if (newVal.directionalLight) {
        scene.add(directionalLight);;
      } else {
        scene.remove(directionalLight);
      }
      if (newVal.pointLight) {
        scene.add(pointLight);
      } else {
        scene.remove(pointLight);
      }
      // 更新环境光源
      ambientLight.intensity = newVal.ambientLightIntensity;
      ambientLight.color.set(newVal.ambientLightColor);
      // 更新平行光源
      pointLight.intensity = newVal.pointLightIntensity;
      pointLight.color.set(newVal.pointLightColor);
      pointLight.position.set(newVal.pointLightPositionX, newVal.pointLightPositionY, newVal.pointLightPositionZ);
      // 更新点光源
      directionalLight.intensity = newVal.directionalLightIntensity;
      directionalLight.color.set(newVal.directionalLightColor);
      directionalLight.position.set(newVal.directionalLightPositionX, newVal.directionalLightPositionY, newVal.directionalLightPositionZ);
    });

    /***********************加载地图信息********************** */
    // await loadMapInfo('icpark_MapData.txt');
    // await loadMapInfo('konggangB1_MapData.txt')
    // await loadMapInfo('konggangB2_MapData.txt')
    // await loadMapInfo('qibuguangchangB1_MapData.txt')
    await loadMapInfo('扬州SMB2_B1_MapData.txt')
    // 渲染地图信息
    // 对渲染时间进行计时
    console.time('renderEntity');
    await renderEntityOpt();
    console.timeEnd('renderEntity');
  })

  /**
   * @description: 从项目文件路径中读取txt文件中加载地图信息
   * @param {*} filePath txt文件路径
   * @return {*}
   */  
   async function loadMapInfo(filePath) {
    const response = await fetch(filePath);
    const txtContent = await response.text();
    mapInfo = JSON.parse(txtContent);
    console.log('mapInfo', mapInfo);
    mapInfo = mapInfo.B1
  }


  /**
   * @description: 渲染实体(优化后)
   * @return {*}
   */  
  async function renderEntityOpt() {
    // 从本地配置文件加载
    loadLocalConfiguration()

    // 获取实体信息
    let parkingSpaceMapData = mapInfo.parkingSpace === undefined ? [] : mapInfo.parkingSpace;
    let wallMapData = mapInfo.wall === undefined ? [] : mapInfo.wall;
    let laneLinesMapData = mapInfo.laneLines === undefined ? [] : mapInfo.laneLines;
    let passengerElevatorMapData = mapInfo.passengerElevator === undefined ? [] : mapInfo.passengerElevator;
    let entranceExitMapData = mapInfo.entranceExit === undefined ? [] : mapInfo.entranceExit;
    let entranceMapData = mapInfo.entrance === undefined ? [] : mapInfo.entrance;
    let exitMapData = mapInfo.exit === undefined ? [] : mapInfo.exit;
    let groundMapData = mapInfo.ground === undefined ? [] : mapInfo.ground;
    let textMapData =  mapInfo.text === undefined ? [] : mapInfo.text;
    let parkingSpaceBackgroundMapData = mapInfo.parkingSpaceBackground === undefined ? [] : mapInfo.parkingSpaceBackground;
    let arresterMapData = mapInfo.arrester === undefined ? [] : mapInfo.arrester;
    console.log(parkingSpaceMapData)

    // 渲染停车位相关实体
    let parkingSpaceGeometry = [];
    let parkingSpaceBorderGeometry = [];
    parkingSpaceMapData.forEach(parkingSpace => {
      // 添加停车位的边框线几何体
      for (let i = 0; i < parkingSpace.coordinates.length - 1; i++) {
        parkingSpaceBorderGeometry.push(new THREE.BufferGeometry().setFromPoints([new THREE.Vector3(parkingSpace.coordinates[i][0], parkingSpace.coordinates[i][1], 0), new THREE.Vector3(parkingSpace.coordinates[i + 1][0], parkingSpace.coordinates[i + 1][1], 0)]));
      }
      console.log(parkingSpace)
      // 添加停车位几何体
      parkingSpaceGeometry.push(render.generateParkingSpacesGeometry(parkingSpace.center, parkingSpace.longer_edge, parkingSpace.shorter_edge, parkingSpace.text_angle))
      // 渲染停车位的号码(用css2dRenderer渲染文字)
      let parkingSpaceTextModel = render.renderParkingSpaceTextByCSS2DRender(parkingSpace.center, parkingSpace.name);
      scene.add(parkingSpaceTextModel);
      labelModels.push(parkingSpaceTextModel);
    }); 
    // 创建停车位的Mesh
    if (parkingSpaceGeometry.length !== 0) {
      const mergedParkingSpaceGeometry = BufferGeometryUtils.mergeGeometries(parkingSpaceGeometry, false);
      const parkingSpaceMesh = new THREE.Mesh(mergedParkingSpaceGeometry, materialForParkingSpace);
      parkingSpaceMesh.userData.type = 'parkingSpace';
      parkingSpaceMesh.castShadow = true;
      parkingSpaceMesh.receiveShadow = true;
      scene.add(parkingSpaceMesh);
    }
    
    // 创建停车位边框的Mesh
    if (parkingSpaceBorderGeometry.length !== 0) {
      const mergedParkingSpaceBorderGeometry = BufferGeometryUtils.mergeGeometries(parkingSpaceBorderGeometry, false);
      const parkingSpaceBorderMesh = new THREE.LineSegments(mergedParkingSpaceBorderGeometry, materialForParkingSpaceBorder);
      parkingSpaceBorderMesh.userData.type = 'parkingSpaceBorder';
      scene.add(parkingSpaceBorderMesh);
    }

    // 渲染停车场背景
    let parkingSpaceBackgroundGeometry = [];
    parkingSpaceBackgroundMapData.forEach(parkingSpaceBackground => {
      parkingSpaceBackgroundGeometry.push(render.generateParkingSpacesBackgroundGeometry(parkingSpaceBackground.coordinates));
    });
    
    // 创建停车位背景的Mesh
    if (parkingSpaceBackgroundGeometry.length !== 0) {
      const mergedParkingSpaceBackgroundGeometry = BufferGeometryUtils.mergeGeometries(parkingSpaceBackgroundGeometry, false);
      const parkingSpaceBackgroundMesh = new THREE.Mesh(mergedParkingSpaceBackgroundGeometry, materialForParkingSpaceBackground);
      parkingSpaceBackgroundMesh.userData.type = 'parkingSpaceBackground';
      // 添加光影
      parkingSpaceBackgroundMesh.castShadow = true;
      parkingSpaceBackgroundMesh.receiveShadow = true;
      scene.add(parkingSpaceBackgroundMesh);
    }

    // 渲染阻车器
    let arresterGeometry = [];
    arresterMapData.forEach(arrester => {
      arresterGeometry.push(render.generateArresterGeometry(arrester.coordinates));
    });
    // 创建阻车器的Mesh
    if (arresterGeometry.length !== 0) {
      const mergedArresterGeometry = BufferGeometryUtils.mergeGeometries(arresterGeometry, false);
      const arresterMesh = new THREE.Mesh(mergedArresterGeometry, materialForArrester);
      arresterMesh.userData.type = 'arrester';
      // 添加光影
      arresterMesh.castShadow = true;
      // arresterMesh.receiveShadow = true;
      scene.add(arresterMesh);
    }

    // 渲染墙壁
    let wallGeometry = [];
    wallMapData.forEach(wall => {
      wallGeometry.push(render.generateWallGeometry(wall.coordinates));
    });

    // 创建墙壁的Mesh
    if (wallGeometry.length !== 0) {
      const mergedWallGeometry = BufferGeometryUtils.mergeGeometries(wallGeometry, false);
      const wallMesh = new THREE.Mesh(mergedWallGeometry, materialForWall);
      wallMesh.userData.type = 'wall';
      // 添加光影
      wallMesh.castShadow = true;
      // wallMesh.receiveShadow = true;
      scene.add(wallMesh);
    }

    // 渲染车道线
    let laneLinesGeometry = [];
    laneLinesMapData.forEach(laneLines => {
      for (let i = 0; i < laneLines.coordinates.length - 1; i++) {
        laneLinesGeometry.push(new THREE.BufferGeometry().setFromPoints([new THREE.Vector3(laneLines.coordinates[i][0], laneLines.coordinates[i][1], 0), new THREE.Vector3(laneLines.coordinates[i + 1][0], laneLines.coordinates[i + 1][1], 0)]));
      }
    });
    // 创建车道线的Mesh
    if (laneLinesGeometry.length !== 0) {
      const mergedLaneLinesGeometry = BufferGeometryUtils.mergeGeometries(laneLinesGeometry, false);
      const laneLinesMesh = new THREE.LineSegments(mergedLaneLinesGeometry, materialForLaneLines);
      laneLinesMesh.userData.type = 'laneLines';
      scene.add(laneLinesMesh);
    }

    // 渲染电梯
    let elevatorGeometry = [];
    passengerElevatorMapData.forEach(elevator => {
      elevatorGeometry.push(render.generatePassengerElevatorGeometry(elevator.coordinates));
    });
    // 创建电梯的Mesh
    if (elevatorGeometry.length !== 0) {
      const mergedElevatorGeometry = BufferGeometryUtils.mergeGeometries(elevatorGeometry, false);
      const elevatorMesh = new THREE.Mesh(mergedElevatorGeometry, materialForPassageElevator);
      elevatorMesh.userData.type = 'elevator';
      scene.add(elevatorMesh);
    }

    // 渲染地板
    if (groundMapData.length !== 0) {
      groundMapData.forEach(ground => {
        scene.add(render.renderGround(materialForGround, ground.coordinates));
      });
    }
    

    // 渲染出入口
    if (entranceMapData.length !== 0) {
      entranceMapData.forEach(entrance => {
        let entranceModel = render.renderEntrance(entrance.coordinates);
        scene.add(entranceModel);
        labelModels.push(entranceModel);
      });
    }

    // 渲染文字
    if (textMapData.length !== 0) {
      textMapData.forEach(text => {
        // 渲染电梯文字
        if (text.type === 'elevator_text') {
          let elevatorTextModel = render.renderElevatorText(text.name, text.coordinates);
          scene.add(elevatorTextModel);
          labelModels.push(elevatorTextModel);
        } else {
          let textModel = render.renderText(text.name, text.coordinates);
          scene.add(textModel)
          labelModels.push(textModel)
        }
      });
    }


    
    
    /**
     * @description: Three.js渲染函数
     * @param {*} time 时间
     * @return {*}
     */    
    function animate(time) {
      collisionDetection();
      requestAnimationFrame( animate );
      renderer.render( scene, camera );
      labelRenderer.render( scene, camera );
      // 轨道控制器更新
      controls.update();
      // 打印相机位置
      // console.log("camera position", camera.position);
      // 打印controls.target
      // console.log("controls.target", controls.target);
    }
    animate();
  }


  /**
   * @description: 对基于CSS2DRenderer渲染的标签模型进行标签检测
   * @return {*}
   */  
   function collisionDetection() {
    // 每轮循环前将四叉树清空（因为是动态的）
    myTree.clear();
    let myObjects = [];
    // 重新向四叉树中插入节点
    for(let i = 0; i < labelModels.length; i++) {
      // 首先判断标签是否被实际几何体遮挡
      const labelPosition = new THREE.Vector3();
      const cameraPosition = new THREE.Vector3();
      labelModels[i].getWorldPosition(labelPosition);
      camera.getWorldPosition(cameraPosition);
      const distanceToLabel = cameraPosition.distanceTo(labelPosition);
      if (distanceToLabel > 2) {
        labelModels[i].element.style.visibility = 'hidden';;
      } else {
        labelModels[i].element.style.visibility = 'visible';
      }
      let rec = labelModels[i].element.getBoundingClientRect();
      let x = (rec.left + rec.right) / 2;
      let y = (rec.top + rec.bottom) / 2;
      let width = rec.width;
      let height = rec.height;
      myObjects.push({
        x: x,
        y: y,
        width: width,
        height: height,
        element: labelModels[i],
      });
      myTree.insert({
        x: x,
        y: y,
        width: width,
        height: height,
        element: labelModels[i],
      });
    }
    // 检测碰撞
    for(let i = 0; i < myObjects.length; i++) {
      // 根据标签的可见性判断是否需要进行碰撞检测
      if (myObjects[i].element.element.style.visibility === 'visible') {
        let candidates = myTree.retrieve(myObjects[i]);
        for(let j = 0; j < candidates.length; j++) {
          if(!isSame(myObjects[i], candidates[j])) {
            if (isOverlapping(myObjects[i], candidates[j])) {
              candidates[j].element.element.style.visibility = 'hidden';
            }
          }
        }
      }
    }
  }

  /**
   * @description: 判断两个四叉树节点对象是否相同
   * @param {*} object1 第一个四叉树节点对象
   * @param {*} object2 第二个四叉树节点对象
   * @return {*}
   */  
  function isSame(object1, object2) {
    return object1.x === object2.x && object1.y === object2.y && object1.width === object2.width && object1.height === object2.height;
  }

  
  function isOverlapping(myObjects1, myObjects2) {
    return !(myObjects1.x + myObjects1.width < myObjects2.x ||
              myObjects1.x > myObjects2.x + myObjects2.width ||
              myObjects1.y + myObjects1.height < myObjects2.y ||
              myObjects1.y > myObjects2.y + myObjects2.height);
  }


  

  /***********************用户交互函数********************** */
  /**
   * @description: 加载配置参数
   * @return {*}
   */  
   function loadConfiguration() {
    // 动态创建文件输入元素
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.style.display = 'none';

    // 文件选择事件
    fileInput.onchange = function(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = function(e) {
          const content = e.target.result;
          const configuration = JSON.parse(content);
          // 加载配置到当前的配置对象中
          Object.assign(baseData, configuration.baseData);
          Object.assign(groundData, configuration.groundData);
          Object.assign(parkingSpaceData, configuration.parkingSpaceData);
          Object.assign(wallData, configuration.wallData);
          Object.assign(elevatorData, configuration.elevatorData);
          Object.assign(laneLinesData, configuration.laneLinesData);
          Object.assign(parkingSpaceBackgroundData, configuration.parkingSpaceBackgroundData);
          Object.assign(lightData, configuration.lightData);
      };
        reader.readAsText(file);
      }
    };
    // 添加到文档并点击
    document.body.appendChild(fileInput);
    fileInput.click();
    // 移除文件输入元素
    document.body.removeChild(fileInput);   
  }


  /***
   * @description: 从指定配置文件中提取配置参数，如果没有找到则退出
   */
  function loadLocalConfiguration() {
    const filePath = "theme.json";
    // 读取文件内容
    fetch(filePath)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        // 将读取到的配置参数应用到当前的配置对象中
        Object.assign(baseData, data.baseData);
        Object.assign(groundData, data.groundData);
        Object.assign(parkingSpaceData, data.parkingSpaceData);
        Object.assign(wallData, data.wallData);
        Object.assign(elevatorData, data.elevatorData);
        Object.assign(laneLinesData, data.laneLinesData);
        Object.assign(parkingSpaceBackgroundData, data.parkingSpaceBackgroundData);
        Object.assign(lightData, data.lightData);
      })
      .catch(error => {
        console.error('Error loading configuration:', error);
      });
  }

  /**
   * @description: 保存配置参数
   * @return {*}
   */
  function saveConfiguration() {
    console.log("保存配置");
    // 将所有配置参数收集到一个对象中
    const configuration = {
        baseData,
        groundData,
        parkingSpaceData,
        wallData,
        elevatorData,
        laneLinesData,
        parkingSpaceBackgroundData,
        lightData
    };
    // 将配置对象转换为JSON字符串
    const jsonString = JSON.stringify(configuration, null, 2);
    // 创建一个Blob对象
    const blob = new Blob([jsonString], { type: 'application/json' });
    // 创建下载链接
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'configuration.json';
    document.body.appendChild(link);
    link.click();
    // 移除下载链接
    document.body.removeChild(link);
  }

  /**
   * @description: 导出GLTF模型
   * @return {*}
   */
  function exportGLTFModel() {
    const exporter = new GLTFExporter();
    // 解析你的场景或者对象
    exporter.parse( scene, function ( gltf ) {
      // 将生成的json转换为字符串
      const output = JSON.stringify( gltf, null, 2 );
      // 创建一个blob对象
      const blob = new Blob( [ output ], { type: 'text/plain' } );
      // 创建一个链接并下载
      const link = document.createElement( 'a' );
      link.href = URL.createObjectURL( blob );
      link.download = 'file.gltf';
      link.click();
    }, { binary: false } );
  }

  /**
   * @description: 导出OBJ模型
   * @return {*}
   */
  function exportOBJModel() {
    // 创建一个导出器实例
    const exporter = new OBJExporter();
    // 解析你的场景或者对象
    const result = exporter.parse( scene );
    // 创建一个blob对象
    const blob = new Blob( [ result ], { type: 'text/plain' } );
    // 创建一个链接并下载
    const link = document.createElement( 'a' );
    link.href = URL.createObjectURL( blob );
    link.download = 'file.obj';
    link.click();
  }

  /**
   * @description: 上传停车位材质贴图的监听函数
   * @return {*}
   */
  const uploadParkingSpaceMaterialMap = (event) => {
    const file = event.target.files[0];
    if (!file) {
      parkingSpaceData.texture = null;
      return;
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      const texture = new THREE.TextureLoader().load(e.target.result, (texture) => {
        // 检查纹理尺寸，如果太小则设置重复
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.repeat.set(4, 4);
      });
      parkingSpaceData.texture = texture;
    };
    reader.readAsDataURL(file);
  };

  /**
   * @description: 上传墙壁材质贴图的监听函数
   * @return {*}
   */
  const uploadWallMaterialMap = (event) => {
    const file = event.target.files[0];
    if (!file) {
      wallData.texture = null;
      return;
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      const texture = new THREE.TextureLoader().load(e.target.result, (texture) => {
        // 检查纹理尺寸，如果太小则设置重复
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.repeat.set(4, 4);
      });
      wallData.texture = texture;
    };
    reader.readAsDataURL(file);
  };

  /**
   * @description: 上传地板材质贴图的监听函数
   * @return {*}
   */
  const uploadGroundMaterialMap = (event) => {
    const file = event.target.files[0];
    if (!file) {
      groundData.texture = null;
      return;
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      const texture = new THREE.TextureLoader().load(e.target.result, (texture) => {
        // 检查纹理尺寸，如果太小则设置重复
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.repeat.set(4, 4);
      });
      groundData.texture = texture;
    };
    reader.readAsDataURL(file);
  };

  /**
   * @description: 上传电梯材质贴图的监听函数
   * @return {*}
   */
  const uploadElevatorMaterialMap = (event) => {
    const file = event.target.files[0];
    if (!file) {
      elevatorData.texture = null;
      return;
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      const texture = new THREE.TextureLoader().load(e.target.result, (texture) => {
        // 检查纹理尺寸，如果太小则设置重复
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.repeat.set(4, 4);
      });
      elevatorData.texture = texture;
    };
    reader.readAsDataURL(file);
  };


  /**
   * @description: 修改材质的函数
   * @param {*} object 
   * @param {*} newVal
   * @return {*}
   */  
  function materialChange(object, newVal) {
    // 判断材质类型是否一致
    if (object.material.type !== newVal.material) {
      // 根据材质类型创建不同的材质
      if (newVal.material === '基础材质') {
        object.material = new THREE.MeshBasicMaterial();
      } else if (newVal.material === 'Blinn-Phong模型材质') {
        object.material = new THREE.MeshPhongMaterial();
      } else if (newVal.material === 'Lambertian模型材质') {
        object.material = new THREE.MeshLambertMaterial();
      } else if (newVal.material === '物理模型材质') {
        object.material = new THREE.MeshPhysicalMaterial();
      } else if (newVal.material === '标准材质<') {
        object.material = new THREE.MeshStandardMaterial();
      } else if (newVal.material === '卡通材质') {
        object.material = new THREE.MeshToonMaterial();
      }
    }
    // 修改材质的属性
    object.material.color.set(newVal.color);
    object.material.transparent = newVal.transparent;
    object.material.opacity = newVal.opacity;
    if (newVal.texture !== null) {
      object.material.map = newVal.texture;
      object.material.needsUpdate = true;
    }
  }


  // 调整模型的高度
  function adjustHeight(mesh, height) {
    const positionAttribute = mesh.geometry.attributes.position;
    const vertexCount = positionAttribute.count;

    for (let i = 0; i < vertexCount; i++) {
      const z = positionAttribute.getZ(i);
      if (z !== 0) {
        positionAttribute.setZ(i, height);
      }
      
    }

    // 更新几何体以反映更改
    mesh.geometry.attributes.position.needsUpdate = true;
    mesh.geometry.computeBoundingBox();
    mesh.geometry.computeBoundingSphere();
  }






  
</script>


<style>
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Poppins', sans-serif;
  }
  /* GUI未active的CSS格式 */
  .gui {
    position : fixed;
    width : 60px;
    height : 60px;
    transition-delay: 0.5s;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    margin-left: 10px;
    z-index : 99999;
  }
  /* GUIactive的CSS格式 */
  .gui.active {
    position : fixed;
    height: 310px;
    width : 60%;
    transition-delay: 0.5s;
    margin-left: 10px;
    z-index : 99999;
  }

  /* 菜单导航栏的所有CSS格式 */
  /* navigation未active的格式 */
  .navigation {
    position : relative;
    width : 60px;
    height : 60px;
    background : #fff;
    border-radius : 50%;
    transition : 0.5s;
    transition-delay: 0.5s;
    border-radius : 60px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    box-shadow : 0 10px 15px rgba(0,0,0,0.5);
  }
  /* navigation active的格式 */
  .navigation.active {
    width : 100%;
    background: linear-gradient(90deg, #d3d3d3, #f0f0f0, #d3d3d3); 
    background-size: 300% 100%;
    animation: gradient1 5s infinite;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius : 15px;
    border-top-right-radius : 15px;
    box-shadow: 0 10px 5px -5px rgba(0,0,0,0.5);
  }
  @keyframes gradient1 {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
  /* 菜单导航栏开关按钮的CSS格式 */
  .navigation .toggleMenu
  {
    position: absolute;
    width: 60px;
    height: 60px;
    background-color: #fff;
    border-radius: 50%;
    transition: 0.5s;
    cursor: pointer;
    transition-delay: 0.5s;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .navigation.active .toggleMenu
  {
    background-color: #5f90e5;
    transition-delay: 0s;
    transform: translateY(260px);
    width: 30px;
    height: 30px;
    box-shadow: 0 10px 15px rgba(0, 0, 0, .05);
  }

  .navigation .toggleMenu::before
  {
    content: '';
    position: absolute;
    width: 30px;
    height: 3px;
    border-radius: 3px;
    background-color: #333;
    transform: translateY(-5px);
    transition: 0.1s;
    transition-delay: 0;
  }

  .navigation .toggleMenu::after
  {
    content: '';
    position: absolute;
    width: 30px;
    height: 3px;
    border-radius: 3px;
    background-color: #333;
    transform: translateY(5px);
    transition: 0.1s;
    transition-delay: 0;
  }

  .navigation.active .toggleMenu::before
  {
    background-color: #fff;
    transform: translateY(0) rotate(45deg) scale(0.6);
    transition-delay: 0;
  }

  .navigation.active .toggleMenu::after
  {
    background-color: #fff;
    transform: translateY(0) rotate(315deg) scale(0.6);
    transition-delay: 0;
  }

  .navigation li
  {
    list-style: none;
    transition: 0.5s;
    transform: scale(0);
  }

  .navigation.active li
  {
    transition-delay: 0.75s;
    display: flex;
    transform: scale(1);
  }

  .navigation li a
  {
    text-decoration: none;
    color: #333;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    padding: 5px 15px;
    border-radius: 20px;
    transition: 0.5s;
  }

  .navigation.active li a:hover
  {
    background-color: #5f90e5;
    color: #fff;
    cursor: pointer;
  }
  /* 菜单导航栏某个选项被选中的CSS格式 */
  .selected {
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    padding: 5px 15px;
    border-radius: 20px;
    background-color: #5f90e5;
    color: #fff;
    cursor: pointer;
  }

  /* 功能区的CSS格式 */
  .function-area {
    width: 100%;
    height: 200px;
    transition: transform 0.5s ease;
    transform: scale(0);
    transform-origin: top left; 
  }

  .function-area.active {
    transition-delay: 0.5s;
    transform: scale(1);
    transform-origin: top left;
    background: linear-gradient(90deg, #f0f0f0, #d3d3d3, #f0f0f0);
    background-size: 300% 100%;
    animation: gradient2 5s infinite;
    border-bottom-left-radius : 15px;
    border-bottom-right-radius : 15px;
    border-top: 1px solid #aba7a7;
  }
  @keyframes gradient2 {
    0% { background-position: 100% 50%; }
    50% { background-position: 0% 50%; }
    100% { background-position: 100% 50%; }
  }
  .function-area-item {
    height : 100%;
    width : 100%;
    display: flex;
  }

  /* 每个功能区域的部分区域样式 */
  .function-area-item-part {
    height : 100%;
    width : 25%;
    display: flex; /* 设置为Flex容器 */
    flex-direction: column; /* 子元素按列排布 */
    align-items: center; /* 在交叉轴方向上居中对齐 */
  }

  /* 给所有.function-area-item-part元素添加右边的边线 */
  .function-area-item-part {
    border-right: 1px solid #aba7a7; /* 边线颜色可以根据需要调整 */
  }

  /* 移除第四个.function-area-item-part元素的右边边线 */
  .function-area-item-part:nth-child(4) {
    border-right: none;
  }

  .function-area-item-part a {
    margin: 0.5em;
  }

  /* color range checkbox选项的样式 */
  .color-options, .range-option, .checkbox-option , .choice-option, .upload-option {
    height : 20%;
    width : 100%;
    display : flex;
    flex-direction: row;
    align-items : center;
  }

  .color-options .option-label, .range-option .option-label, .checkbox-option .option-label{
    margin-left: 0.5em;
    width : 50%;
    text-shadow: 4px 4px 10px rgba(0, 0, 0, 0.7);
  }

  .choice-option .option-label, .upload-option .option-label {
    margin-left: 0.5em;
    width : 30%;
    text-shadow: 4px 4px 10px rgba(0, 0, 0, 0.7);
  }

  .color-options .option-value, .range-option .option-value, .checkbox-option .option-value{
    width : 50%;
  }

  .choice-option .option-value, .upload-option .option-value {
    width : 70%;
  }


  /* color 选项的样式 */
  .color-input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: transparent;
    width: 40px;
    height: 40px;
    border: none;
  }
  .color-input::-webkit-color-swatch {
    /* border: 3px solid #000000; */
    border-radius: 8px;
  }
  .color-input::-moz-color-swatch {
    /* border: 3px solid #000000; */
    border-radius: 8px;
  }
  /* range 的CSS格式 */

  .range-option .option-value span {
    margin-left: 0.5em;
    width : 20%; 
  }

  input[type=range] {
    -webkit-appearance: none;
    width: 100px;
    border-radius: 10px; /*这个属性设置使填充进度条时的图形为圆角*/
  }
  input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
  }    

  input[type=range]::-webkit-slider-runnable-track {
    height: 15px;
    border-radius: 10px; /*将轨道设为圆角的*/
    box-shadow: 0 1px 1px #def3f8, inset 0 .125em .125em #0d1112; /*轨道内置阴影效果*/
  }
  input[type=range]:focus {
    outline: none;
  }
  input[type=range]::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 25px;
    width: 25px;
    margin-top: -5px; /*使滑块超出轨道部分的偏移量相等*/
    background: #ffffff; 
    border-radius: 50%; /*外观设置为圆形*/
    border: solid 0.125em rgba(205, 224, 230, 0.5); /*设置边框*/
    box-shadow: 0 .125em .125em #3b4547; /*添加底部阴影*/
  }
  
  /* checkbox的CSS格式 */

  input[type="checkbox"] {
    appearance: none;
    width: 25px;
    height: 25px;
    background: #ddd;
    border-radius: 5px;
    border: 1px solid #333;
    position: relative;
    cursor: pointer;
    transition: background 0.3s ease-in-out;
  }

  input[type="checkbox"]:checked {
    border: 1px solid #333;
    background: #007bff;
  }

  input[type="checkbox"]:checked::after {
    content: '';
    position: absolute;
    width: 10px;
    height: 5px;
    border: 4px solid white;
    border-top: none;
    border-right: none;
    top: 5px;
    left: 5px;
    transform: rotate(-45deg);
  }

  /* button-option的CSS格式 */
  
  .button-option {
    --b:4px;   /* border length*/
    --c:20px;  /* the cube perspective */
    --g:calc(var(--c)*0.707); /* 0.707 = cos(45deg) = sin(45deg) */
    padding:8px;
    transition: 0.5s;
    border: solid transparent;
    border-width:var(--b) var(--b) calc(var(--c) + var(--b)) calc(var(--c) + var(--b));
    background:
      linear-gradient(-45deg,transparent var(--g),rgba(255,255,255,0.6) 0) left  /var(--c) 100%,
      linear-gradient(135deg,transparent var(--g),rgba(255,255,255,0.3) 0) bottom /100% var(--c),
      conic-gradient(from -90deg at top var(--b)   right var(--b),currentColor 270deg,transparent 0),
      conic-gradient(from  90deg at bottom calc(var(--c) + var(--b)) left calc(var(--c) + var(--b)),currentColor 270deg,transparent 0) ;
    background-repeat:no-repeat;
    background-origin:border-box;
    transform:translate(calc(var(--c)/-1),calc(var(--c)/1));
    clip-path: 
      polygon(var(--c) 0%, var(--c) 0%, 
      100% 0%, 
      100% calc(100% - var(--c)),100% calc(100% - var(--c)),
      var(--c) calc(100% - var(--c)),
      var(--c) calc(100% - var(--c)));
  }
  .button-option:hover {
    transform:translate(0,0);
    clip-path: 
      polygon(0% var(--c), var(--c) 0%, 
      100% 0%, 
      100% calc(100% - var(--c)), calc(100% - var(--c)) 100%, 
      0% 100%,0% 100%);
    cursor: pointer;
  }

  /***下拉选择框*** */

  .choice-input {
    height: 30px;
    position: relative;
    width: 160px;
  }

  .choice-input svg {
    position: absolute;
    right: 12px;
    top: calc(50% - 3px);
    width: 10px;
    height: 6px;
    stroke-width: 2px;
    stroke: #9098A9;
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    pointer-events: none;
  }

  .choice-input select {
    -webkit-appearance: none;
    padding: 7px 40px 7px 12px;
    width: 100%;
    border: 1px solid #E8EAED;
    border-radius: 5px;
    background: white;
    box-shadow: 0 1px 3px -2px #9098A9;
    cursor: pointer;
    font-family: inherit;
    font-size: 16px;
    transition: all 150ms ease;
  }

  .choice-input select:required:invalid {
    color: #5A667F;
  }

  .choice-input select option {
    color: #223254;
  }

  .choice-input select option[value=""][disabled] {
    display: none;
  }

  .choice-input select:focus {
    outline: none;
    border-color: #0077FF;
    box-shadow: 0 0 0 2px rgba(0, 119, 255, 0.2);
  }

  .choice-input select:hover + svg {
    stroke: #0077FF;
  }

  .sprites {
    position: absolute;
    width: 0;
    height: 0;
    pointer-events: none;
    user-select: none;
  }

  /*** 文件上传** */
  .upload-input {
    text-align: center;
    display:flex;
    align-items: center;
    justify-content: center;
    position: relative;
    display: inline-block;
    overflow: hidden;
    cursor: pointer;
    background-color: #ffffff;
    color: #333;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
    height: 30px;
    width : 160px;
  }

  .upload-input:hover {
    background-color: #f7f7f7;
    border-color: #bbb;
  }

  .upload-input input[type="file"] {
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }


</style>